module.exports = __webpack_public_path__ + "img/E2 UP4.927ca6bd.png";